export const CREATE_COURSE = "CREATE_COURSE";
export const LOAD_COURSES_SUCCESS = "LOAD_COURSES_SUCCESS";
export const LOAD_CITIES_SUCCESS = "LOAD_CITIES_SUCCESS";
export const LOAD_CATEGORIES_SUCCESS = "LOAD_CATEGORIES_SUCCESS";
export const ADD_CATEGORY_OPTIMISTIC = "ADD_CATEGORY_OPTIMISTIC";
export const LOAD_UNAPPROVED_CATEGORIES_SUCCESS = "LOAD_UNAPPROVED_CATEGORIES_SUCCESS";
export const APPROVE_CATEGORY_OPTIMISTIC = "APPROVE_CATEGORY_OPTIMISTIC";
export const REJECT_CATEGORY_OPTIMISTIC = "REJECT_CATEGORY_OPTIMISTIC";
export const LOAD_TARGETGROUPS_SUCCESS = "LOAD_TARGETGROUPS_SUCCESS";
export const ADD_TARGETGROUP_OPTIMISTIC = "ADD_TARGETGROUP_OPTIMISTIC";
export const LOAD_UNAPPROVED_TARGETGROUPS_SUCCESS = "LOAD_UNAPPROVED_TARGETGROUPS_SUCCESS";
export const APPROVE_TARGETGROUP_OPTIMISTIC = "APPROVE_TARGETGROUP_OPTIMISTIC";
export const REMOVE_TARGETGROUP_OPTIMISTIC = "REMOVE_TARGETGROUP_OPTIMISTIC";
export const LOAD_FOODS_SUCCESS = "LOAD_FOODS_SUCCESS";
export const LOAD_FOODCOST_SUCCESS = "LOAD_FOODCOST_SUCCESS";
export const LOAD_AUTHORS_SUCCESS = "LOAD_AUTHORS_SUCCESS";
export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const DELETE_COURSE_OPTIMISTIC = "DELETE_COURSE_OPTIMISTIC";
export const LOAD_EVENTS_SUCCESS = "LOAD_EVENTS_SUCCESS";
export const LOAD_ATTENDING_SUCCESS = "LOAD_ATTENDING_SUCCESS";
export const LOAD_EVENT_SUCCESS = "LOAD_EVENT_SUCCESS";
export const UPDATE_DATE = "UPDATE_DATE";
export const UPDATE_SELECTED_CITY = "UPDATE_SELECTED_CITY";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const DELETE_EVENT_OPTIMISTIC = "DELETE_EVENT_OPTIMISTIC";
export const LOGIN_USER = "LOGIN_USER";
export const SIGNUP_OPTIMISTIC = "SIGNUP_OPTIMISTIC";
export const UN_SIGNUP_OPTIMISTIC = "UN_SIGNUP_OPTIMISTIC";
export const REPORT_OPTIMISTIC = "REPORT_OPTIMISTIC";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const LOAD_NETWORK_SUCCESS = "LOAD_NETWORK_SUCCESS";
export const SEARCH_PROFILES_SUCCESS = "SEARCH_PROFILES_SUCCESS";
export const LOAD_REPORTS_SUCCESS = "LOAD_REPORTS_SUCCESS";
export const PASS_PROFILE_OR_EVENT_OPTIMISTIC = "PASS_PROFILE_OR_EVENT_OPTIMISTIC";
export const FAIL_PROFILE_OPTIMISTIC = "FAIL_PROFILE_OPTIMISTIC";
export const FAIL_EVENT_OPTIMISTIC = "FAIL_EVENT_OPTIMISTIC";
export const ADD_SIBLINGS_OPTIMISTIC = "ADD_SIBLINGS_OPTIMISTIC";
export const LOAD_BIBLE_VERSE_SUCCESS = "LOAD_BIBLE_VERSE_SUCCESS";
